import {
  CursorPaginationQuerySchema,
  apiEndpoint,
  cursorPaginatedResponse,
  publicApi,
} from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { MONITORING_SERVICE } from "../config/index.ts";
import { HealthProbe } from "../models/index.ts";

export const monitoringPublicApi = publicApi(
  { domain: API_DOMAIN, path: `${MONITORING_SERVICE.LABEL}/pub` },
  {
    getHealthProbes: apiEndpoint("GET", {
      queryParams: z.object(
        {
          ...CursorPaginationQuerySchema.shape,
          target: HealthProbe.shape.target,
        },
        {
          ...CursorPaginationQuerySchema.descriptions,
          target: HealthProbe.descriptions.target,
        },
      ),
      response: cursorPaginatedResponse(HealthProbe.schema),
    }),
  },
);
